var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-text-field", {
        staticClass: "mb-2",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Buscar dashboard",
          dense: "",
          outlined: "",
          clearable: "",
          "hide-details": "",
        },
        model: {
          value: _setup.search,
          callback: function ($$v) {
            _setup.search = $$v
          },
          expression: "search",
        },
      }),
      _c("div", { staticClass: "caption grey--text mb-3" }, [
        _vm._v(
          _vm._s(_setup.selectedCount) +
            " de " +
            _vm._s(_setup.charts.length) +
            " selecionados"
        ),
      ]),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _c(
            "v-list",
            [
              _vm._l(_setup.filteredCharts, function (chart, idx) {
                return [
                  idx > 0
                    ? _c("v-divider", { key: "d-" + chart.id })
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    { key: chart.id },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v(_vm._s(chart.name))])],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        [
                          _c("v-switch", {
                            staticClass: "pa-0 ma-0",
                            attrs: {
                              value: chart.id,
                              color: "green darken-2",
                              "hide-details": "",
                              dense: "",
                            },
                            on: { change: _setup.apply },
                            model: {
                              value: _setup.selected,
                              callback: function ($$v) {
                                _setup.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
          !_setup.filteredCharts.length
            ? _c(
                "div",
                { staticClass: "text-center grey--text py-4 caption" },
                [_vm._v("Nenhum dashboard encontrado.")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }